<template>
  <div class="navbar">
    <div class="main">
      <div class="logo">
        <img :src="curUser.companyLogo || logo" @click="go('home')" class="pointer" />
      </div>
      <div class="company-name font-topic-bold" style="color: #ffffff;">
        {{ curUser.companyShort }}
      </div>
    </div>
    <div class="setting-box">
      <div class="other">
        <a
          href="https://www.yuque.com/books/share/2ba8b201-efff-40a6-b08b-5972ec777ef6?#"
          target="_blank"
          class="svg-icon"
        >
          <svg-icon icon-class="help" style="color: #ffffff"></svg-icon>
        </a>
        <el-badge :max="99" :hidden="unreadMessageCount === 0" :value="unreadMessageCount">
          <span class="svg-icon" style="margin-left: 10px" @click="go('system-message')">
            <svg-icon style="color: #ffffff" icon-class="bell"></svg-icon>
          </span>
        </el-badge>
        <dropdown-menu
          width="240"
          :menu-list="menuList"
          @click="handleMenuClick"
          trigger="click"
          from="navbar"
        >
          <span class="icon-open-menu pointer">
            <staff-avatar :size="32" :user="curUser" :compress="false"></staff-avatar>
            <i class="el-icon-caret-bottom" style="color: #ffffff"></i>
          </span>
        </dropdown-menu>
      </div>
    </div>
    <base-dialog :visible.sync="skinDialogVisible" :show-close="true">
      <template v-slot:header>
        <div>主题换肤</div>
      </template>
      <div class="skin-wrap">
        <div class="skin-card" @click="setSkin('standard')">
          <span class="skin-icon">
            <svg-icon icon-class="menu_standard"></svg-icon>
          </span>
        </div>
        <div class="skin-card" @click="setSkin('simple')">
          <span class="skin-icon">
            <svg-icon icon-class="menu_simple"></svg-icon>
          </span>
        </div>
      </div>
    </base-dialog>
    <base-dialog
      :visible.sync="currentContextDialogVisible"
      class="context-dialog"
      :show-close="true"
      width="400px"
    >
      <div v-loading="!contextUrl" class="scan-wrapper">
        <div class="title">当前环境</div>
        <div class="url">{{ url }}</div>
        <div class="point">请使用轻单移动端扫码添加环境</div>
        <div class="qr-wrapper">
          <vue-qr class="qr" :text="contextUrl" :margin="0" :size="220"></vue-qr>
          <div @click="gotoQr">
            <img
              v-if="showScanHelp"
              class="scan-help-img"
              src="~~/images/login/scan_tip.png"
              alt=""
            />
          </div>
        </div>
        <div class="footer">
          <span
            class="pointer code-info"
            :style="{ color: showScanHelp ? '#1989FA' : 'inherit' }"
            @click="switchScanHelp"
          >
            使用帮助
          </span>
          <span style="margin: 0 10px">|</span>
          <span class="pointer code-info" @click="goAppDownload">下载轻单APP</span>
        </div>
      </div>
    </base-dialog>
  </div>
</template>

<script>
import Navbar from "./Navbar"
export default {
  name: "navbar-backend",
  extends: Navbar
}
</script>

<style lang="scss" scoped>
.navbar {
  z-index: 100;
  position: relative;
  height: $navbar-height;
  box-shadow: 0 2px 4px 0 #d8d8d8;
  background: #545d6e;
  overflow: hidden;
  display: flex;
  .main {
    display: flex;
    align-items: center;
    .side-btn {
      height: $navbar-height;
      img {
        width: $navbar-height;
        height: $navbar-height;
        object-fit: cover;
      }
    }
    .logo {
      img {
        max-height: 32px;
        max-width: 64px;
      }
      margin-left: 20px;
    }
    .company-name {
      margin-left: 20px;
    }
  }
  .setting-box {
    margin-left: auto;
    margin-right: 22px;
    display: flex;
    align-items: center;
    & > * {
      margin-left: 18px;
    }
    .el-button {
      font-size: $font-size-main;
      color: #535c65;
      .svg-icon {
        font-size: 24px;
        color: #535c65;
        vertical-align: middle;
      }
    }
    .separator {
      width: 1px;
      height: 18px;
      background: $color-font-second;
    }
    .other {
      display: flex;
      align-items: center;
      .svg-icon {
        color: #c0c4cc;
        font-size: 24px;
        cursor: pointer;
      }
      .el-badge {
        ::v-deep .el-badge__content {
          top: 3px;
        }
      }
      .el-avatar {
        margin-left: 15px;
        background: $color-auxiliary;
      }
      .icon-open-menu {
        display: flex;
        align-items: center;
        &:focus {
          outline: none;
        }
        i {
          padding: 3px;
        }
      }
    }
  }
}
.skin-wrap {
  display: flex;
  margin: 30px 18px;
  justify-content: space-between;
}
.skin-card {
  display: flex;
  flex-flow: column;
  text-align: center;
  align-items: center;
  width: 228px;
  height: 150px;
  color: $color-font-title;
  font-weight: bold;
  border-radius: 6px;
  box-sizing: border-box;
  cursor: pointer;
  overflow: hidden;
  .skin-icon {
    margin: -74px;
    font-size: 230px;
  }
  &:hover {
    background-color: #e5e5e5;
  }
}
.context-dialog {
  .scan-wrapper {
    display: flex;
    flex-flow: column;
    align-items: center;
    .title {
      font-size: 27px;
      font-weight: bold;
      color: #1989fa;
      margin-bottom: 3px;
    }
    .url {
      color: #000000;
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 10px;
    }
    .point {
      font-size: 16px;
      margin-bottom: 18px;
    }
    .qr-wrapper {
      position: relative;
      .mask {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        display: flex;
        flex-flow: column;
        align-items: center;
        justify-content: center;
        img {
          width: 78px;
          height: 78px;
        }
        p {
          margin-top: 10px;
          font-size: 16px;
          font-weight: 500;
          color: #ffffff;
        }
      }
      .scan-help-img {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        background: white;
      }
    }
    .footer {
      margin-top: 24px;
    }
  }
  ::v-deep {
    .el-dialog {
      border-radius: 10px;
    }
    .el-dialog__body {
      padding: 50px 22px !important;
    }
  }
}
</style>
